import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = unknown, false = logged out, obj = logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    if (!localStorage.getItem("biomac_token")) {
      setAdmin(false);
      setLoading(false);
      return () => {};
    }
    api
      .get("/admin/me")
      .then((res) => mounted && setAdmin(res.data))
      .catch(() => mounted && setAdmin(false))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    localStorage.setItem("biomac_token", data.token);
    setAdmin(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/admin/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("biomac_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
